/**
 * Canvas-env React context + hook, split out from `env.tsx` so that the
 * component module exports only `<EnvProvider>` (keeps React Fast Refresh
 * working). The provider lives in `env.tsx` and supplies this context's value.
 */

import { createContext, useContext } from "react";
import type { CanvasEnv } from "@canvas-sync/shared";

export interface EnvContextValue {
  env: CanvasEnv;
  setEnv: (next: CanvasEnv) => void;
}

export const EnvContext = createContext<EnvContextValue>({
  env: "test",
  setEnv: () => {},
});

export function useCanvasEnv(): EnvContextValue {
  return useContext(EnvContext);
}
